module.exports = __webpack_public_path__ + "img/photo.2d982351.jpg";